// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../assets/backgrounds/BG_Desktop_Orange.png");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".slide-wrapper[data-v-ad90ce4a]{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-size:contain}[data-v-ad90ce4a] .videoWrapper{background-color:#ffebc9}[data-v-ad90ce4a] .dark>.video-js{background-color:#ffa200!important}", ""]);
// Exports
module.exports = exports;
